import React from 'react';
import { useTranslation } from 'react-i18next';

import { Locked, DashboardMarket, IdTypeVisa } from '@swyftx/aviary/icons/outlined';

import { InfoCard } from '../common/InfoCard';
import { LoansSection } from '../common/LoansSection';

const LoansWhyChooseCBL: React.FC = () => {
  const { t } = useTranslation('loans');
  const icons = [
    <DashboardMarket
      key='dashboard-icon'
      className='h-[32px] w-[32px] shrink-0 rounded-8 bg-color-background-info-subtle p-4 text-color-text-accent'
    />,
    <IdTypeVisa
      key='visa-icon'
      className='h-[32px] w-[32px] shrink-0 rounded-8 bg-color-background-info-subtle p-4 text-color-text-accent'
    />,
    <Locked
      key='locked-icon'
      className='h-[32px] w-[32px] shrink-0 rounded-8 bg-color-background-info-subtle p-4 text-color-text-accent'
    />,
  ];

  return (
    <LoansSection
      header={{
        title: t('WhyChooseCBL.heading.title'),
        description: t('WhyChooseCBL.heading.description'),
      }}
      content={<InfoCard pageName='WhyChooseCBL' icons={icons} />}
    />
  );
};

LoansWhyChooseCBL.displayName = 'LoansWhyChooseCBL';

export { LoansWhyChooseCBL };
